import { render, staticRenderFns } from "./AccountFranchisorMobileMenu.vue?vue&type=template&id=613f85d5&scoped=true&"
import script from "./AccountFranchisorMobileMenu.vue?vue&type=script&lang=js&"
export * from "./AccountFranchisorMobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountFranchisorMobileMenu.vue?vue&type=style&index=0&id=613f85d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f85d5",
  null
  
)

export default component.exports